<template>
    <div>
        <div class="main-content" id="panel">
            <header-component></header-component>
            <div class="header pb-5 bg-gradient-lighter pt-3">
                <div class="row ml-2 mr-2">
                    <div class="col-sm-6">
                        <div class="card" >
                            <div class="card-title mx-auto" style="padding-top: 15px;">
                                Mis usuarios Referidos
                            </div>
                            <div class="card-body">
                                <div class="table table-sm table-striped table-responsive">
                                    <DataTable :value="referred" responsiveLayout="scroll" class="table">
                                        <template #header>
                                            <div class="row">
                                                <button class="btn btn-primary btn-sm mx-auto"  @click="displayModal=true"><i class="	fa fa-user"></i> Agregar referido</button>
                                            </div>
                                        </template>
                                        <Column class="cart-product-thumbnail" field="nombre" header="Nombre"></Column>
                                        <Column class="cart-product-thumbnail" field="apellidos" header="Apellidos"></Column>
                                        <Column class="cart-product-thumbnail" field="email" header="Correo"></Column>
                                        <Column class="cart-product-thumbnail"  header="Aciones">
                                            <template #body="slotProps">
                                                <i style="padding: 2px;" @click.prevent="edit(slotProps.data.id)" class="pi pi-user-edit"></i> 
                                                
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="card" >
                            <div class="card-title mx-auto" style="padding-top: 15px;">
                                Mi Testimonio 
                            </div>
                            <div class="card-body">
                                <button style="float: right;" class="btn btn-primary btn-sm mx-auto"  @click="displayReview=true"><i class="fa fa-star"></i> Editar Reseña</button>
                                <h4>Reseña</h4>
                                <Rating v-model="rating" :cancel="false" />
                                <br/>
                                <br/>
                                <Panel>
                                    <p>Esta plataforma ha sido de mucha utilidad para mi vida formación profesional. Cada curso que he tomado
                                        ha sido de mucha ayuda para mi preparación, agradezco infinitamente a GCA por las posibilidades que brinda a 
                                        profesionales como yo.
                                    </p>
                                </Panel>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
        <Dialog class="" header="Agregar Referido" :visible.sync="displayModal" :containerStyle="{width: '50vw'}" :modal="true">
            <AddReferred @eventname="closeAddReferred"></AddReferred>
        </Dialog>
        <Dialog class="" header="Editar Referido" :visible.sync="displayEdit" :containerStyle="{width: '50vw'}" :modal="true">
            <EditReferred :idUser="this.idSelectedUser" @eventname="closeEditReferred"></EditReferred>
        </Dialog>
        <Dialog class="" header="Editar Testimonio" :visible.sync="displayReview" :containerStyle="{width: '50vw'}" :modal="true">
            <AddReview @eventname="closeReview"></AddReview>
        </Dialog>
    </div>
    
</template>
<script>
import HeaderComponent from '@/components/HeaderComponent'
import AddReferred from '@/components/ReferredUsers/AddReferred'
import EditReferred from '@/components/ReferredUsers/EditReferred'
import AddReview from '@/components/Raiting/AddReview'

export default {
    name: 'ReferredUsers',
    components: {
        HeaderComponent,
        AddReferred,
        EditReferred,
        AddReview
    },
    data() {
        return {
            displayReview:false,
            displayModal: false,
            displayEdit: false,
            idSelectedUser: 0,
            usuario: null,
            referred: [
            ],
            rating: 5
        }
    },
    methods: {
        async getReferred() {
            this.openLoading()
            await axios.get(apiKS + 'api/gca/referrals?user_id=' + this.usuario.id, { headers })
            .then( (response) => {
                console.log(JSON.stringify(response.data.data))
                this.referred = [...response.data.data]
                Swal.close()
            })
            .catch( error => {
                this.catchError(error)
            })

            this.bExams = true
        }, 
        edit(id){
            this.idSelectedUser = id
            this.displayEdit = true;
        },
        async remove(id){
            let band = false
            await Swal.fire({
				title: 'Eliminar',
				text: "¿Desea eliminar el referido?",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Si, Eliminalo',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
                console.log('Result: ' + JSON.stringify(result))
				if (result.value) {
					band = true
				}
				else{
					Swal.fire('No se eliminó la compra')
                    return
				}
			})

            if(!band){
                return
            }

            this.openLoading()
            await axios.delete(apiKS + 'api/gca/referrals/' + id,  { headers })
                .then( response => {
                    Swal.close()
                    this.showMessage('Exito', response.data.message, 'success')
                    this.getReferred()
            } )
            .catch( error => {
                this.catchError(error)
            } )
        },
        closeAddReferred(){
            this.displayModal = false
            this.getReferred()
        },
        closeEditReferred(){
            this.displayEdit = false
            this.getReferred()
        },
        closeReview(){
            this.displayReview = false
        }        
    },
    async mounted() {
        if(!user) {
            await this.getUserApi()
            this.usuario = user
        } else {
            this.usuario = user
        }
        await this.getReferred()
    },
    watch: {
        
    }
}
</script>
<style >

.p-dialog, .p-dialog-mask.p-component-overlay {
    pointer-events: auto;
}
.p-component-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.p-dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    pointer-events: none;
}
.p-component-overlay-enter {
    animation: p-component-overlay-enter-animation 150ms forwards;
}
.p-component-overlay {
    background-color: rgba(0, 0, 0, 0.4);
    transition-duration: 0.2s;
}

.p-component, .p-component * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.p-dialog {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    max-height: 90%;
    -webkit-transform: scale(1);
    transform: scale(1);
}
.p-dialog, .p-dialog-mask.p-component-overlay {
    pointer-events: auto;
}
.p-dialog {
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    border: 0 none;
}
.p-component {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 1rem;
    font-weight: normal;
}

.p-dialog .p-dialog-header {
    border-bottom: 0 none;
    background: #ffffff;
    color: #343a40;
    padding: 1.5rem;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
}

.p-component, .p-component * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.p-dialog-footer, .p-dialog-header {
    -ms-flex-negative: 0;
    flex-shrink: 0;
}

.p-dialog-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.p-dialog .p-dialog-content {
    background: #ffffff;
    color: #495057;
    padding: 0 1.5rem 2rem 1.5rem;
}

.p-component, .p-component * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.p-dialog-content {
    overflow-y: auto;
}

.p-dialog .p-dialog-footer {
    border-top: 0 none;
    background: #ffffff;
    color: #495057;
    padding: 0 1.5rem 1.5rem 1.5rem;
    text-align: right;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
}

.p-component, .p-component * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.p-dialog-footer, .p-dialog-header {
    -ms-flex-negative: 0;
    flex-shrink: 0;
}









.p-dialog .p-dialog-header-icon, .p-dialog .p-dialog-header-icons {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.p-component, .p-component * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.p-dialog .p-dialog-header .p-dialog-header-icon:last-child {
    margin-right: 0;
}
.p-dialog .p-dialog-header .p-dialog-header-icon {
    width: 2rem;
    height: 2rem;
    color: #6c757d;
    border: 0 none;
    background: transparent;
    border-radius: 50%;
    transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
    margin-right: 0.5rem;
}

.p-dialog .p-dialog-header-icon {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
}
.p-dialog .p-dialog-header-icon, .p-dialog .p-dialog-header-icons {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.p-link {
    text-align: left;
    background-color: transparent;
    margin: 0;
    padding: 0;
    border: none;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.p-component, .p-component * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.p-link {
    font-size: 1rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    border-radius: 6px;
}
button, input[type=button], input[type=file]::-webkit-file-upload-button, input[type=reset], input[type=submit] {
    border-radius: 0;
}

.pi {
    font-family: primeicons;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.p-component, .p-component * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.pi {
    font-size: 1rem;
}
.p-ink {
    display: block;
    position: absolute;
    background: hsla(0,0%,100%,.5);
    border-radius: 100%;
    -webkit-transform: scale(0);
    transform: scale(0);
    pointer-events: none;
}

.p-component, .p-component * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>